import { Injectable } from '@angular/core';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { CacheService } from '@app/services/cache.service';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { UsersApi } from '@core/services/user/user.api';
import { InviteResponse } from '@core/services/user/user.interface';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { IPartner, IUsersItems } from '../domain/models/admin';

@Injectable({ providedIn: 'root' })
export class AdminResourcesService {
	private _updatedUser$: Subject<IAssignOrganizationTransfer> = new Subject<IAssignOrganizationTransfer>();

	constructor(
		private toasterService: WrapToasterService,
		private apiFacade: ApiFacadeService,
		private cache: CacheService,
		private userApi: UsersApi,
	) {}

	public assignToOrg(orgs: string[], uuid: string, wl: string): Observable<{ success: boolean }> {
		const cacheKey = 'admin-users';

		const url = `admin/users/${wl.toLowerCase()}/${uuid}/assign`;
		const payload = { org_list: orgs.map(String) };

		return this.apiFacade.put<{ success: boolean }>(url, payload, {}).pipe(
			tap(() => {
				this._updatedUser$.next({
					uuid,
					orgs,
				});
				if (!this.cache.get(cacheKey)) {
					return;
				}
				this.cache.get<IUsersItems[]>(cacheKey).find((u) => u.uuid === uuid).organisations = orgs.map(Number);
			}),
			map(() => ({ success: true })),
			catchError((error) => {
				this.toasterService.handleRequestFailed(error);
				return of({ success: false });
			}),
		);
	}

	public assignOrgToPartner(organizations: string[], reseller_id: number) {
		const cacheKey = 'admin-partners';

		const url = `admin/partners/${reseller_id}/organizations`;
		const body = { organizations };

		return this.apiFacade.put(url, body).pipe(
			tap(() => {
				if (!this.cache.get(cacheKey)) {
					return;
				}
				this.cache.get<IPartner[]>(cacheKey).find((p) => p.reseller_id === reseller_id).organizations = organizations;
			}),
			catchError((error) => {
				this.toasterService.handleRequestFailed(error);
				return of({ success: false });
			}),
		);
	}

	public inviteUser(reseller_id: string, email: string, send_email: boolean): Observable<InviteResponse> {
		return this.userApi.invite({ email, reseller_id, send_email }, true);
	}
}

interface IAssignOrganizationTransfer {
	orgs: string[];
	uuid: string;
}
